export enum RTPProfilesAPIRoutes {
    GET_PROFILES = "games:rtp-profile:query",
    GET_SUBSIDIARIES = "subsidiary:query",
    CREATE_PROFILE = "games:rtp-profile:create",
    EDIT_PROFILE = "games:rtp-profile:edit",
    SET_DEFAULT_PROFILE = "games:rtp-profile:default:set",
    REMOVE_DEFAULT_PROFILE = "games:rtp-profile:default:remove"
}
